import { render } from "./CoursesArea.vue?vue&type=template&id=e0e83c74"
import script from "./CoursesArea.vue?vue&type=script&lang=js"
export * from "./CoursesArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__